module.exports = __webpack_public_path__ + "img/icons_28.18f25390.svg";